// src/components/UserMenu.js
import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { FaUserAlt, FaSignOutAlt, FaCog, FaChevronDown, FaBook } from "react-icons/fa";
import PreferenciasModal from "./PreferenciasModal";
import ManualesModal from "./ManualesModal";

export default function UserMenu() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [showManuales, setShowManuales] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (!menuRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const getInitials = (name) => {
    if (!name) return "?";
    const names = name.split(" ");
    return names.map((n) => n[0]).join("").substring(0, 2).toUpperCase();
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-3 hover:bg-slate-100 px-2 py-1.5 rounded-md transition"
      >
        {user?.icono ? (
          <img
            src={user.icono}
            alt="avatar"
            className="w-9 h-9 rounded-full object-cover border border-slate-200 shrink-0"
          />
        ) : (
          <div className="w-9 h-9 rounded-full bg-indigo-600 text-white flex items-center justify-center font-semibold text-sm shrink-0">
            {getInitials(user?.nombre)}
          </div>
        )}

        <div className="hidden sm:flex flex-col items-start leading-tight text-left">
          <span className="text-sm font-semibold text-slate-800">{user?.nombre || "Usuario"}</span>
          <span className="text-xs text-slate-500">{user?.email || ""}</span>
        </div>

        <FaChevronDown className="text-xs text-slate-400 hidden sm:block" />
      </button>

      {/* DROPDOWN USUARIO */}
      {open && (
        <div className="absolute right-0 mt-2 w-60 bg-white text-slate-700 shadow-lg border border-slate-200 rounded-lg z-50 overflow-hidden py-1">

          {/* Nombre y correo: visible aquí siempre (en escritorio ya se ve también junto al avatar) */}
          <div className="sm:hidden px-3.5 py-2.5 border-b border-slate-100">
            <p className="text-sm font-semibold text-slate-800 truncate">{user?.nombre || "Usuario"}</p>
            <p className="text-xs text-slate-500 truncate">{user?.email || ""}</p>
          </div>

          {/* OPCIONES */}
          <Link
            to="/dashboard/perfil"
            className="flex items-center gap-2.5 px-3.5 py-2 text-sm hover:bg-slate-50 hover:text-indigo-600 transition"
            onClick={() => setOpen(false)}
          >
            <FaUserAlt className="text-[13px] text-slate-400" />
            Perfil
          </Link>

          <button
            onClick={() => {
              setShowPrefs(true);
              setOpen(false);
            }}
            className="flex items-center gap-2.5 w-full px-3.5 py-2 text-sm hover:bg-slate-50 hover:text-indigo-600 transition"
          >
            <FaCog className="text-[13px] text-slate-400" />
            Preferencias
          </button>

          <button
            onClick={() => {
              setShowManuales(true);
              setOpen(false);
            }}
            className="flex items-center gap-2.5 w-full px-3.5 py-2 text-sm hover:bg-slate-50 hover:text-indigo-600 transition"
          >
            <FaBook className="text-[13px] text-slate-400" />
            Manuales
          </button>

          <div className="border-t border-slate-100 my-1" />

          <button
            onClick={handleLogout}
            className="flex items-center gap-2.5 w-full px-3.5 py-2 text-sm text-rose-600 hover:bg-rose-50 transition"
          >
            <FaSignOutAlt className="text-[13px]" />
            Cerrar sesión
          </button>

        </div>
      )}

      {showPrefs && <PreferenciasModal onClose={() => setShowPrefs(false)} />}
      {showManuales && <ManualesModal onClose={() => setShowManuales(false)} />}
    </div>
  );
}
